import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOwnerPostAuthTarget, isOwnerAuthenticated } from "../lib/auth-session.ts";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: isOwnerAuthenticated() ? getOwnerPostAuthTarget() : "/login" });
  },
});
